import { builder } from 'common/js/configs/';
import { commonCreativeConfig } from '../common-creative-config';
import { commonBlurEffect } from '../../common/common-blur-effect';
import { commonCta } from '../../common/common-cta';
import { commonBrand } from '../../common/common-brand';
import { brandPriorityOverArrow } from '../../common/brand-or-arrow-priority';

export const formatConfigUnmarshaller = {
  creative: builder.holder({
    url: commonCreativeConfig.url,
    creativeRatio: commonCreativeConfig.creativeRatio,
    objectFit: builder.string('creative_object_fit', {
      possibleValues: [
        {
          name: 'Cover',
          value: 'cover'
        },
        {
          name: 'Contain',
          value: 'contain'
        }
      ],
      defaultValue: 'contain'
    })
  }),
  ...commonBlurEffect,
  ...commonCta,
  ...commonBrand,
  ...brandPriorityOverArrow
};
